module.exports = __webpack_public_path__ + "static/media/048-boy-5.4f206b0e.svg";